// Moves each product card's quick "Add" button out of the image area so it can sit
// on the price row (bottom-right of the card) and the product name can use the full width.
function moveQuickAdd(root) {
  root.querySelectorAll('product-card .card-gallery quick-add-component').forEach((qa) => {
    const content = qa.closest('.product-card__content');
    if (content) {
      content.appendChild(qa);
      content.classList.add('apts-has-add');
    }
  });
}
moveQuickAdd(document);
new MutationObserver((muts) => {
  for (const m of muts) {
    for (const n of m.addedNodes) {
      if (n.nodeType === 1 && (n.matches?.('product-card, quick-add-component') || n.querySelector?.('product-card quick-add-component'))) {
        moveQuickAdd(n.matches?.('quick-add-component') ? n.closest('product-card') || document : n);
      }
    }
  }
}).observe(document.documentElement, { childList: true, subtree: true });
